<template>
  <section class="section-book-cleaner-from-profile form-book-cleaner">

    <!-- Experience unvailable service area -->
    <div v-if="experience.unavailable_service_area && $mq.desktop">
      <div class="px-3">
        <span class="text-danger"><i class="fas fa-exclamation-circle"></i> {{ $t('message.experience.unavailable_service_area') }}</span>
        <div class="pt-2">
          <button type="button" class="btn btn-block btn-outline-info btn-sm" @click="openModal()">
            {{ $t('message.subscription.see_details') }}
          </button>
        </div> 
        <hr>
      </div>
    </div>

    <template v-if="selectedService === null">
      <div class="row">
        <div class="col-12">
          <h3>
            {{ $t('message.booking.new_booking.book_a_service') }}:
            <span v-html="$options.filters.serviceParentName(experience.service_id, globalState.services)"></span>
          </h3>
          <hr>
        </div>
      </div>
      <template v-for="(service, index) in experience.services">
        <div class="d-flex justify-content-start align-items-center py-0 px-4" v-if="!service.is_hidden">
          <div class="flex-grow-1">
            <h3 class="booking-service-title">{{ service | multiLangName }}</h3>
            <h3 class="my-0">{{ service.cost | currency }}</h3>
          </div>
          <div class="text-right">
            <button class="btn btn-info px-3 py-2" @click="setSelectedService(service)">
              {{ $t('message.button.book') }}
            </button>
          </div>
        </div>
        <div class="px-4" v-if="(index + 1) < experience.services.length">
          <hr class="my-0">
        </div>
      </template>
    </template>

    <template v-else>
      <div class="row mb-3">
        <div class="col-12 text-right">
          <a href="" class="text-primary-link-underline" @click.prevent="selectedService = null">
            <i class="fal fa-angle-left"></i> {{ $t('message.booking.booking_step.change_new_service') }}
          </a>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h3 class="booking-service-title">{{ selectedService | multiLangName }}</h3>
        </div>
        <div class="col-12">
          <span class="price-per-hour">{{ selectedService.cost | currency }}</span>
          <hr>
        </div>
      </div>
      <!-- /.row price per hour -->

      <section v-if="professionalCalendar">
        <div class="row" v-if="state.userPlaces && checkUserPlaces(state.userPlaces, experience.province_id)">
          <div class="col-12">
            <div class="form-group">
              <h4 class="pb-2">{{ $t('message.booking.booking_step.my_place') }}</h4>
              <div class="select-jumbo">
                <select class="form-control" v-model="selectedUserPlaceId">
                  <option value="">
                    {{ $t('message.booking.booking_step.please_select') }}
                  </option>
                  <option :value="userPlace.id" v-for="userPlace in state.userPlaces"
                          v-if="state.userPlaceCities[userPlace.id] === experience.province_id">
                    {{ userPlace.place_name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- /.row user places -->

        <div class="row mt-3">
          <div class="col-12">
            <h4 class="pb-2">{{ $t('message.booking.new_booking.pick_a_date') }}</h4>
          </div>
          <div class="col-6 pr-2">
            <div class="form-group">
              <input type="text"
                     placeholder="DD/MM/YYYY"
                     class="form-control -date-picker input-jumbo"
                     @change="displayAvailableDuration"
                     v-pikaday:professionalCalendar="professionalCalendar"
                     ref="cleaningDate" readonly>
              <span class="far fa-calendar-alt input-text-icon"></span>
            </div>
          </div>
          <!-- /. calendar -->

          <div class="col-6 pl-2">
            <div class="form-group">
              <template v-if="!isFetchingProfessionalCalendarJobs">
                <div v-if="availableTimes.length > 0">
                  <div class="select-jumbo">
                    <select style="background: white;" class="form-control" v-model="selectedTime">
                      <option :value="time" v-for="time in availableTimes">{{ time }}</option>
                    </select>
                    <span class="far fa-clock input-text-icon"></span>
                  </div>
                </div>
                <div class="select-jumbo" v-else-if="selectedDate === null">
                  <div class="select-jumbo">
                    <select style="background: white;" class="form-control" v-model="selectedTime">
                      <option :value="time" v-for="time in globalState.times">{{ time }}</option>
                    </select>
                    <span class="far fa-clock input-text-icon"></span>
                  </div>
                </div>
                <div v-else>
                  <span class="text-orange">{{ $t('message.alert.sold_out') }}</span>
                </div>
              </template>
              <template v-else>
                <div class="text-center">
                  <img src="/static/img/ring.gif" width="32"> {{ $t('message.button.loading') }}
                </div>
              </template>
            </div>
          </div>
          <!-- /. time -->
        </div>
        <!-- /.row -->

        <div class="row">
          <div class="col-md-12 mb-1" v-if="partialBlockedDuration">
            <ul class="list-unstyled calendar-job-list">
              <li>
                {{ $t('message.professional.available_time') }}:
                <span class="text-primary">
                <span v-if="partialBlockedDuration === ''">{{ $t('message.professional.all_day') }}</span>
                <span v-else="">{{ partialBlockedDuration }}</span>
              </span>
              </li>
              <template v-if="professionalCalendarJobs">
                <li v-for="job in professionalCalendarJobs">
                  {{ $t('message.professional.booked_by_other_user') }}:
                  <span class="text-orange"
                        v-html="$options.filters.cleaningDuration(job.cleaning_date, job.work_hour)"></span>
                </li>
              </template>
            </ul>
          </div>
        </div>
        <!-- /. available time -->
        <div class="row mt-3">
          <div class="col-md-12">
            <ul class="list-unstyled summary-list">
              <li>
                <div class="row">
                  <div class="col-8 p-0">
                    <label class="total-price">
                      {{ $t('message.booking.new_booking.subtotal') }}
                    </label>
                  </div>
                  <div class="col-4 p-0 text-right">
                    <label class="total-price text-primary">
                      {{ selectedService.cost | currency }}
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- /. row -->

        <div class="row">
          <div class="col-12 text-remark text-danger mb-2" v-if="experience.active === 0 || professional.active === 0">
            {{ $t('message.professional.inactive_status') }}
          </div>
          <div class="col-12 text-center">
            <button class="btn btn-info btn-block"
                    :class="[(experience.active === 0 || professional.active === 0) ? 'button-disabled': '']"
                    :disabled="(experience.active === 0 || professional.active === 0)"
                    @click="checkProfessionalAvailable">
              {{ $t(isCheckingText) }}
            </button>
            <template v-if="$mq.desktop && user">
              <div class="my-1">- {{ $t('message.hero.or') }} -</div>
              <router-link tag="a"
                           :to="{ path: '/message', query: { cid: 0, pid: professional.id }}"
                           class="btn btn-outline-info btn-block">
                {{ $t('message.professional.contact_cleaner') }}
              </router-link>
            </template>
          </div>
        </div>
        <!-- /. row -->
      </section>
      <section v-else>
        <loader/>
      </section>
    </template>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Loader from '../../loader/Loader'
  import moment from 'moment-timezone'
  import userEventLogHelpers from '../../../helpers/userEventLogHelpers'
  import serviceHelpers from '../../../helpers/serviceHelpers'
  import insiderHelpers from '../../../helpers/insiderHelpers'

  export default {
    props: ['professional', 'experience', 'from'],
    components: {
      Loader
    },
    data () {
      return {
        professionalId: null,
        selectedService: null,
        selectedServiceId: 1,
        selectedUserPlaceId: '',
        selectedProvinceId: 1,
        selectedDate: null,
        selectedTime: '07:00',
        selectedWorkHour: '2.0',
        selectedPlaceSize: 1,
        email: '',
        costPerHour: this.professional.cost_per_hour,
        partialBlockedDuration: null,
        availableStartTime: null,
        availableEndTime: null,
        availableTimes: [],
        sortBy: (this.$i18n.locale === 'th') ? 'name_th' : 'name_en',
        loadingAvailableTimes: false
      }
    },
    computed: {
      ...mapGetters({
        isChecking: 'booking/getIsChecking',
        isCheckingText: 'booking/getIsCheckingText',
        isCheckingTextInstantBook: 'booking/getIsCheckingInstantBook',
        isFetchingProfessionalCalendarJobs: 'professionalCalendar/getIsFetchingProfessionalCalendarJobs',
        globalState: 'globalVal/getState',
        preBookingData: 'booking/getPreBookingData',
        professionalAvailable: 'booking/getProfessionalAvailable',
        professionalCalendar: 'professionalCalendar/getProfessionalCalendar',
        professionalCalendarJobs: 'professionalCalendar/getProfessionalCalendarJobs',
        professionalCalendarState: 'professionalCalendar/getState',
        provinceDiscounts: 'booking/getProvinceDiscounts',
        state: 'booking/getState',
        user: 'auth/getUser'
      }),
      sortedPlaceSizes () {
        return this._.orderBy(this.globalState.placeSizes, ['id'], ['asc'])
      }
    },
    watch: {
      professionalCalendar () {
        this.loadFullyBookedDates()
      },
      professionalCalendarJobs () {
        this.initAvailableTimes()
      },
      isChecking () {
        if (!this.state.isChecking && this.state.availability === true && this.$refs.cleaningDate.value) {
          // Set pre-booking data without email
          const preBookingData = {
            service_id: this.selectedServiceId,
            user_place_id: this.selectedUserPlaceId,
            province_id: this.selectedProvinceId,
            cleaning_date: this.$refs.cleaningDate.value,
            cleaning_time: this.selectedTime,
            work_hour: this.selectedWorkHour,
            init_work_hour: this.selectedWorkHour,
            place_size_id: this.selectedPlaceSize,
            email: '',
            service: this.selectedService,
            experience_id: this.experience.id
          }
          // Set user email
          if (this.user) {
            preBookingData.email = this.user.email
          }
          this.$store.commit('booking/SET_PRE_BOOKING_DATA', preBookingData)

          // Set selected professional
          const selectedProfessional = {
            id: this.professionalId,
            name: this.professional.name,
            picture: this.professional.picture,
            jobQty: this.professional.job_qty,
            active: this.professional.active,
            province_id: this.professional.province_id,
            is_excellent: this.professional.is_excellent,
            latitude: this.professional.latitude,
            longitude: this.professional.longitude
          }
          this.$store.commit('booking/SET_SELECTED_PROFESSIONAL', selectedProfessional)

          // Update total price
          this.$store.commit('booking/UPDATE_TOTAL_PRICE', this.selectedService.cost)

          if (this.user === null || (this.user && Number(this.user.id) === 0)) {
            // alert('login')
            this.checkLogin()
          } else {
            // Go to contact process of booking
            // Set booking from in order to back to previous page correctly
            const bookingFrom = {
              from: 'experienceDetail',
              experienceId: this.experience.id
            }
            // Hide book cleaner modal and remove style to show scrollbar
            window.$('.modal').modal('hide')
            window.$('html, body').removeAttr('style')
            this.$store.commit('booking/SET_BOOKING_FROM', bookingFrom)
            this.$router.push('/booking/checkout')
          }
        }
      },
      selectedWorkHour () {
        this.loadFullyBookedDates()
      }
    },
    methods: {
      openModal () {
        this.$parent.openUnavailableServiceAreaModal()
      },
      checkUserPlaces (userPlaces, provinceId) {
        let num = 0
        for (let key in userPlaces) {
          const userPlace = userPlaces[key]
          if (userPlace.province_id === provinceId) {
            num += 1
          }
        }
        return num > 0
      },
      setSelectedService (service) {
        this.selectedService = service
        this.selectedServiceId = service.id
        this.selectedWorkHour = service.duration
        // Save user event log
        userEventLogHelpers.logEvent('view_experience_service_list', {
          experience_id: this.experience.id
        })
        userEventLogHelpers.logEvent('begin_booking_experience', {
          service_id: this.selectedServiceId,
          professional_id: this.professionalId,
          experience_id: this.experience.id
        })
        // Insider product page event
        const totalPrice = serviceHelpers.converStringToNumber(this.selectedService.cost)
        const productParams = {
          user: this.user,
          serviceId: this.selectedServiceId,
          provinceId: this.selectedProvinceId,
          totalPrice: totalPrice,
          experienceId: this.experience.id,
          bookingCountType: 'one_time',
          isNoDateTimeBooking: false
        }
        insiderHelpers.productViewEvent(productParams)
      },
      parseTime (s) {
        const c = s.split(':')
        return parseInt(c[0]) * 60 + parseInt(c[1])
      },
      checkAvailableTime (startTime, professionalCalendarJobs) {
        let result = true
        if (professionalCalendarJobs) {
          const hours = Number(this.selectedWorkHour) + 0.5
          if (this.selectedDate) {
            const endTime = moment(this.selectedDate + ' ' + startTime).add(hours, 'hours').format('HH:mm')
            for (let job of professionalCalendarJobs) {
              if (startTime >= job.start_time && startTime <= job.end_time) {
                result = false
                break
              } else {
                const minutes = this.parseTime(startTime) - this.parseTime(job.end_time)
                if (startTime < job.start_time && endTime >= job.start_time) {
                  result = false
                  break
                } else if (startTime > job.end_time && minutes < 60) {
                  result = false
                  break
                }
              }
            }
          }
        }
        // Check available end time comparing with duration if the selected date is partial blocked date
        if (result === true && this.availableEndTime) {
          const minutes = this.parseTime(this.availableEndTime) - this.parseTime(startTime)
          const endMinute = 60 * Number(this.selectedWorkHour)
          if (minutes < endMinute) {
            result = false
          }
        }
        return result
      },
      initAvailableTimes () {
        this.availableTimes.length = 0
        if (this.availableStartTime === null) {
          for (let time in this.globalState.times) {
            if (this.professionalCalendarJobs) {
              const result = this.checkAvailableTime(time, this.professionalCalendarJobs)
              if (result) {
                this.availableTimes.push(time)
              }
            } else {
              this.availableTimes.push(time)
            }
          }
        } else {
          for (let time in this.globalState.times) {
            if (time >= this.availableStartTime && time <= this.availableEndTime) {
              const result = this.checkAvailableTime(time, this.professionalCalendarJobs)
              if (result) {
                this.availableTimes.push(time)
              }
            }
          }
        }
        // Check if selected time is in available time then set its value
        const index = this.availableTimes.indexOf(this.selectedTime)
        if (index > -1) {
          this.selectedTime = this.availableTimes[index]
        } else {
          this.selectedTime = this.availableTimes[0]
        }
      },
      displayAvailableDuration () {
        this.partialBlockedDuration = ''
        this.selectedDate = moment(this.$refs.cleaningDate.value, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const blockedDates = this.professionalCalendar.blockedDates
        this.availableStartTime = null
        this.availableEndTime = null

        for (let key in blockedDates) {
          const blockedDate = blockedDates[key]
          if (blockedDate.blocked_type === 'partial' && blockedDate.date === this.selectedDate) {
            this.availableStartTime = blockedDate.start_time
            this.availableEndTime = blockedDate.end_time
            this.partialBlockedDuration = this.availableStartTime + ' - ' + this.availableEndTime
          }
        }

        if (this.availableStartTime === null) {
          this.selectedTime = '07:00'
        } else {
          this.selectedTime = this.availableStartTime
        }

        // Fetch professional calendar jobs
        const queryData = {
          professional_id: this.professionalId,
          cleaning_date: this.selectedDate
        }
        this.$store.dispatch('professionalCalendar/LOAD_PROFESSIONAL_CALENDAR_JOB_LIST', queryData)
        this.initAvailableTimes()
      },
      checkProfessionalAvailable () {
        if (this.selectedDate) {
          const submitData = {
            professional_id: this.professionalId,
            cleaning_date: this.selectedDate,
            cleaning_time: this.selectedTime,
            work_hour: this.selectedWorkHour,
            province_id: this.professional.province_id
          }
          this.$store.dispatch('booking/CHECK_PROFESSIONAL_AVAILABLE', submitData)
        } else {
          this.$refs.cleaningDate.focus()
          this.$swal(this.$i18n.t('message.alert.select_cleaning_date'))
        }
      },
      checkLogin () {
        const parentComponent = (this.from === 'experienceDetail') ? this.$parent.$parent : this.$parent.$parent.$parent.$parent
        if (('isLoggingIn' in window.localStorage && window.localStorage.getItem('isLoggingIn') === 'false')) {
          if (this.user === null) {
            parentComponent.openModal('login')
          }
        } else {
          parentComponent.openModal('login')
        }
      },
      clearOldBookingData () {
        // Remove pre booking data
        this.$store.commit('booking/SET_PRE_BOOKING_DATA', null)
        // Remove relected professional data
        this.$store.commit('booking/SET_SELECTED_PROFESSIONAL', null)
        // Remove new order data
        // this.$store.commit('booking/SET_NEW_ORDER_DATA', null)
        // Remove preCheckoutData
        this.$store.commit('booking/SET_PRE_CHECKOUT_DATA', null)
        // Remove promo code
        this.$store.commit('promoCode/SET_APPLIED_PROMO_CODE', null)
        // Remove extras
        this.$store.commit('extras/SET_APPLIED_EXTRAS', null)
        this.$store.commit('extras/SET_HAS_APPLIED_EXTRAS', false)
      },
      loadFullyBookedDates () {
        const currentDate = new Date()
        const startDate = moment(currentDate).format('YYYY-MM-DD')
        const queryData = {
          professional_id: this.professionalId,
          start_date: startDate,
          work_hour: this.selectedWorkHour
        }
        this.$store.dispatch('professionalCalendar/LOAD_SOLD_OUT_DATES', queryData)
      }
    },
    mounted () {
      this.clearOldBookingData()
      if (this.professional) {
        this.professionalId = this.professional.id
        this.selectedProvinceId = this.professional.province_id

        // Fetch professional calendar
        const currentDate = new Date()
        const startDate = moment(currentDate).format('YYYY-MM-DD')
        const endDate = moment(currentDate).add(12, 'M').endOf('month').format('YYYY-MM-DD')
        const queryProfessionalCalendarData = {
          professional_id: this.professionalId,
          start_date: startDate,
          end_date: endDate
        }
        this.$store.dispatch('professionalCalendar/LOAD_PROFESSIONAL_CALENDAR', queryProfessionalCalendarData)

        // Fetch user places
        const queryUserPlaceData = {
          user_id: 0,
          province_id: this.experience.province_id
        }
        if (this.user) {
          queryUserPlaceData.user_id = this.user.id
        }
        this.$store.dispatch('booking/LOAD_USER_PLACE_LIST', queryUserPlaceData)
      }

      if (this.preBookingData) {
        this.selectedUserPlaceId = this.preBookingData.user_place_id
        this.selectedDate = this.preBookingData.cleaning_date
        this.selectedTime = this.preBookingData.cleaning_time
        this.selectedCity = this.preBookingData.province_id
        this.selectedPlaceSize = this.preBookingData.place_size_id
        this.selectedWorkHour = this.preBookingData.work_hour
        this.$refs.cleaningDate.value = this.selectedDate
      }
      this.initAvailableTimes()
    }
  }
</script>

<style scoped>
  .input-text-icon {
    float: right;
    margin-right: 0.5rem;
    margin-top: -1.7rem;
    position: relative;
    font-size: 110%;
    z-index: 2;
    color: #9E9E9E;
  }
</style>



// WEBPACK FOOTER //
// src/components/experience/components/BookExperienceForm.vue